import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

const routes: Routes = [
  {
    path: 'start',
    loadChildren: () => import('../pages/startnew/startnew.module').then(m => m.StartNewPageModule)
  },
  /* {
    path: 'start',
    loadChildren: () => import('../pages/termedinfos/termedinfos.module').then(m => m.TermedInfosPageModule)
  }, */
  {
    path: 'suche',
    loadChildren: () => import('../pages/startnew/startnew.module').then(m => m.StartNewPageModule)
  },
  /* {
    path: 'suche',
    loadChildren: () => import('../pages/search/search.module').then(m => m.SearchPageModule)
  }, */
  {
    path: 'searchresults',
    loadChildren: () => import('../pages/search-results/search-results.module').then(m => m.SearchResultsPageModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('../pages/dashboard/dashboard.module').then(m => m.DashboardPageModule)
  },
  {
    path: 'arzt/:id/:name',
    loadChildren: () => import('../pages/doc/docPage.module').then(m => m.DocPageModule)
  },
  {
    path: 'arzt/:id/:name/:request',
    loadChildren: () => import('../pages/doc/docPage.module').then(m => m.DocPageModule)
  },
  {
    path: 'arzt/:id/:name/:request/:eventId',
    loadChildren: () => import('../pages/doc/docPage.module').then(m => m.DocPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('../pages/login/loginPage.module').then(m => m.LoginPageModule)
  },
  {
    path: 'einstellungen',
    loadChildren: () => import('../pages/settings/settings.module').then(m => m.SettingsPageModule)
  },
  {
    path: 'patmedlist',
    loadChildren: () => import('../pages/patmedlist-new/patmedlistnew.module').then(m => m.PatMedListNewModule)
  },
   {
    path: 'buchen/:data',
    loadChildren: () => import('../pages/book/bookPage.module').then(m => m.BookPageModule)
  },
  {
    //i18n fehlt
    path: 'agb',
    loadChildren: () => import('../pages/agb/agbPage.module').then(m => m.AgbPageModule)
  },
  {
    //i18n fehlt
    path: 'legals',
    loadChildren: () => import('../pages/legal/legalPage.module').then(m => m.LegalPageModule)
  },
  {
    //i18n fehlt
    path: 'privacy',
    loadChildren: () => import('../pages/privacy/privacy.module').then(m => m.PrivacyPageModule)
  },
  {
    //i18n fehlt
    path: 'accessibility',
    loadChildren: () => import('../pages/accessibility/accessibility.module').then(m => m.AccessibilityPageModule)
  },
  {
    path: 'nachrichten',
    loadChildren: () => import('../pages/messages/messagesPage.module').then(m => m.MessagesPageModule)
  },
  {
    path: 'praxis/:id/:name',
    loadChildren: () => import('../pages/doc/docPage.module').then(m => m.DocPageModule)
  },
   {
    //i18n fehlt
    path: 'about',
    loadChildren: () => import('../pages/about/aboutPage.module').then(m => m.aboutPageModule)
  },
  {
    path: 'contact',
    loadChildren: () => import('../pages/contact/contact.module').then(m => m.ContactPageModule)
  },
  {
    path: 'faq',
    loadChildren: () => import('../pages/faq/faq.module').then(m => m.FaqPageModule)
  },
  {
    path: 'account/:action/:param1/:param2',
    loadChildren: () => import('../pages/account/accountPage.module').then(m => m.AccountPageModule)
  },
  {
    path: 'account/:action',
    loadChildren: () => import('../pages/account/accountPage.module').then(m => m.AccountPageModule)
  },
  {
    path: 's/:token',
    loadChildren: () => import('../pages/stornoApp/stornoApp.module').then(m => m.stornoAppModule)
  },
  {
    path: 'stornoApp/:token',
    loadChildren: () => import('../pages/stornoApp/stornoApp.module').then(m => m.stornoAppModule)
  },
  {
    path: 'karriere',
    loadChildren: () => import('./../pages/karriere/karriere.module').then(m => m.KarrierePageModule)
  },
  {
    path: 'jobadvert/:id',
    loadChildren: () => import('./../pages/karriere/jobadvert.module').then(m => m.JobadvertPageModule)
  },
  { path: 'products',
    loadChildren: () => import('./../pages/products/products.module').then(m => m.ProductsPageModule)
  },
  { path: 'access',
    loadChildren: () => import('./../pages/products/access.module').then(m => m.AccessPageModule)
  },
  { path: 'connect',
    loadChildren: () => import('./../pages/products/connect.module').then(m => m.ConnectPageModule)
  },
  { path: 'reserve',
    loadChildren: () => import('./../pages/products/reserve.module').then(m => m.ReservePageModule)
  },
  { path: 'schulungen',
    loadChildren: () => import('./../pages/schulung/schulungPage.module').then(m => m.schulungPageModule)
  },
  { path: '10-Jahre',
    loadChildren: () => import('./../pages/zehnJahre/zehnJahre.module').then(m => m.TenYearsPageModule)
  },
  {
    path: '10-jahre',
    loadChildren: () => import('./../pages/zehnJahre/zehnJahre.module').then(m => m.TenYearsPageModule),
    pathMatch: 'full',
  },
  {
    path: 'partner',
    loadChildren: () => import('./../pages/partnerships/partnership.module').then(m => m.PartnershipPageModule),
    pathMatch: 'full',
  },
  {
    path: 'form/:doctor/:uid',
     loadChildren: () => import('../pages/formSwitcher/formSwitcher.module').then(m => m.FormSwitcherModule)
  },
  {
  path: 'medatixx',
  loadChildren: () => import('./../pages/medatixx/medatixx.module').then(m => m.MedatixxPageModule),
  pathMatch: 'full',
  },
  {
  path: 'sales',
  loadChildren: () => import('./../pages/sales/sales.module').then(m => m.SalesPageModule),
  pathMatch: 'full',
  },
  {
    path: 'form/:doctor/:uid/:returnType',
     loadChildren: () => import('../pages/formSwitcher/formSwitcher.module').then(m => m.FormSwitcherModule)
  },
  {
    path: '',
    redirectTo: 'start',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: 'start'
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
    TranslateModule.forChild()
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
